export default {
  computed: {
    chartOptions() {
      const rows = [...this.fcsCompanyRow].reverse()
      return {
        chart: { type: 'spline' },
        title: { text: 'Dollar' },
        responsive: { rules: [{ condition: { maxWidth: 700 }, chartOptions: { legend: { align: 'right', verticalAlign: 'top' } } }] },
        xAxis: { categories: rows.map(r => r.month_name) },
        tooltip: { crosshairs: true, shared: true },
        credits: { enabled: false },
        plotOptions: { spline: { marker: { radius: 4, lineColor: '#666666', lineWidth: 1 } } },
        series: [
          { name: 'Average Balance', data: rows.map(r => parseInt(r.month_average_balance.toFixed(2))) },
          { name: 'Net Deposits Balance', data: rows.map(r => parseInt(r.month_net_deposits.toFixed(2))) },
        ],
      }
    },
  },
}
